import { AGENCY_TYPE } from './agency-type.enum';

export const AGENCY_TYPES_LOOKUP = [
  { value: AGENCY_TYPE.AGENCY, description: AGENCY_TYPE.AGENCY },
  { value: AGENCY_TYPE.MGA, description: AGENCY_TYPE.MGA },
];
